<template>
    <div>
        <card-header icon="fa-merge" title="Merge User"></card-header>

        <card-body v-if="user">
            <div class="columns is-gapless">
                <div class="column">
                    <card-list>
                        <subheader-list-item :title="'MERGE USER ' + user.id" icon="fa-user" />
                    </card-list>

                    <merge-user-details :user="user" :card="card" />
                </div>
                <div class="column" style="border-left: 1px solid #e7e7e7;">
                    <card-list>
                        <subheader-list-item :title="'INTO USER ' + toUserId" icon="fa-arrow-right" />

                        <template v-if="!toUser">
                            <search-list-item @action="searchUser" />

                            <template v-if="users">
                                <subheader-list-item title="Select user..." icon="fa-search" />
                                <user-tile
                                    v-for="u in users"
                                    :card="card"
                                    :user="u"
                                    @click="selectUser(u)"
                                    v-if="user.id !== u.id"
                                />
                            </template>
                        </template>

                        <merge-user-details v-else :user="toUser" :card="card" />

                    </card-list>
                </div>
            </div>
        </card-body>

        <card-footer class="pt-3 pb-3">
            <div class="columns">
                <div class="column has-text-right">
                    <b-button
                        type="is-primary"
                        size="is-small"
                        @click="submit"
                        :disabled="!toUser"
                    ><i class="fas fa-merge mr-2"></i>Merge Users
                    </b-button>
                </div>
            </div>
        </card-footer>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardList from "@/TIER/components/CardList";
    import NavigationListItem from "@/TIER/components/NavigationListItem";
    import CardContainer from "@/TIER/components/CardContainer";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import CardFooter from "@/TIER/components/CardFooter";
    import SeparatorListItem from "@/TIER/components/SeparatorListItem";

    import {client as http} from '@/http_client';
    import SubheaderListItem from "../../TIER/components/SubheaderListItem";
    import DataRow from "../../TIER/components/DataRow.vue";
    import SearchListItem from "../../TIER/components/SearchListItem.vue";
    import UserTile from "../../components/tiles/UserTile.vue";
    import MergeUserDetails from "./MergeUserDetails.vue";

    export default {
        components: {MergeUserDetails, UserTile, SearchListItem, DataRow, SubheaderListItem, SeparatorListItem, CardFooter, CardToolbar, CardContainer, NavigationListItem, CardList, CardBody, CardHeader},
        props: ['card', 'props', 'child'],
        data() {
            return {
                users: null,
                user: null,
                toUser: null,
                toUserId: '...',
                query: '',
                confirm: false,
            };
        },
        computed: {
            ...mapGetters(['currentUser']),
        },
        methods: {
            loadUser: function () {
                this.$emit('loading', true);
                http.get('users/merge/' + this.props.userId + '/' + this.toUserId).then(response => {
                    this.user = response.data.user;
                    this.toUser = response.data.toUser;
                    this.$emit('loading', false);

                    if (this.user) {
                        this.searchUser(this.user.first_name + ' ' + this.user.last_name);
                    }
                });
            },
            searchUser: function (q) {
                this.query = q;
                this.$emit('loading', true);
                http.get('users/search/' + this.query + '/0/30').then(response => {
                    this.users = response.data.users;
                    this.$emit('loading', false);
                });
                console.log('us: search users: ' + this.props.query);
            },
            selectUser: function (u) {
                this.toUser = u.id;
                this.toUserId = u.id;
                this.users = null;
                this.loadUser();
            },
            submit: function () {
                if (confirm('Are you sure you want to merge these users? Please verify the merge direction. User will be deleted once merged.')) {
                    http.post('users/merge', {id: this.user.id, toId: this.toUser.id}).then(response => {
                        this.$openCard('user', {userId: this.toUser.id}, null);
                    });
                }
            }
        },
        watch: {
            'props.userId': function () {
                this.loadUser();
            }
        },
        mounted: function () {
            this.loadUser();
        }
    };
</script>
